import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

const RoleRoute = ({ role, children }: { role: 'dev' | 'tenant'; children: ReactNode }) => {
  const userRole = useSelector((state: RootState) => state.auth.user?.role)
  if (role === 'dev' && userRole !== 'dev') return <Navigate to="/unauthorized" replace />
  if (role === 'tenant' && userRole === 'dev') return <Navigate to="/companies" replace />
  return <>{children}</>
}

export default RoleRoute
